<template>
  <div id = 'career-opportunities' v-if = 'unit'>
    <h2>Contact Information</h2>
    <p>
      <b><code v-html='pointOfContact' class='program-info'></code></b>
      <br>
      <a v-if='phoneNumber' class='contact' target="_parent" :href='phoneNumberM'> {{ phoneNumber }}</a>
      <!-- {{phoneNumber}} -->
      <br>
      <a v-if='email' class='contact' target="_parent" :href="'mailto:' + email">{{ email }}</a>
      <!-- <code v-html='email' class='program-info'></code> -->
    </p>
  </div>
</template>

<script>

// const defaultCareerData = { occupations: [] }

export default {
  name: 'ContactInformation',

  data() {
    return {
    }
  },

  computed: {
    unit() {
      return this.$store.state.unit
    },
    pointOfContact() {
      return this.unit.point_of_contact
    },
    phoneNumber() {
      return this.unit.phone_number
    },
    phoneNumberM() {
      return 'tel: ' + this.unit.phone_number.replace(/[^\w\s]/gi, '')
    },
    email() {
      return this.unit.email
    }
  },

  methods: {
  }
}

</script>



// WEBPACK FOOTER //
// contact_information.vue?2d7a7072